import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-security-black',
  templateUrl: './icon-security-black.component.html',
  styles: []
})
export class IconSecurityBlackComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
